import {fetchJSONByGet} from './index.js'

// GG
// 获取国家列表
export const getCountriesApi = () => fetchJSONByGet('/adms_api_v0/google/countries')
// 获取所有语言全称
export const getFullLanguagesApi = () => fetchJSONByGet('/adms_api_v0/google/languages/full')
// 获取所有语言code
export const getShortLanguagesApi = () => fetchJSONByGet('/adms_api_v0/google/languages/short')